module.exports = __webpack_public_path__ + "img/05.016475ac.png";